import * as React from 'react';

// SVG plano (no createIcon) para conservar el `fill="none"` del root: las formas
// con solo `stroke` se rellenarían de currentColor con createIcon.
type IconProps = React.SVGProps<SVGSVGElement>;

export function CategoriasProductosIcon(props: IconProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 34 34'
      fill='none'
      width={24}
      height={24}
      {...props}>
      <path
        d='M19 4L30 15C31.1 16.1 31.1 17.9 30 19L19 30C17.9 31.1 16.1 31.1 15 30L4 19C3.3 18.3 2.9 17.3 2.9 16.3V7C2.9 4.8 4.8 2.9 7 2.9H16.3C17.3 2.9 18.3 3.3 19 4Z'
        fill='#3885FE'
      />
      <path
        d='M2.9 16.3L15 30C16.1 31.1 17.9 31.1 19 30L21.5 27.5L6.5 12.5L2.9 16.3Z'
        fill='#0E3663'
      />
      <path
        d='M21.5 27.5L30 19C31.1 17.9 31.1 16.1 30 15L22.5 11.5L14.5 19.5L21.5 27.5Z'
        fill='#5CC9BA'
      />
      <circle cx='11' cy='11' r='3.5' fill='white' />
      <circle cx='11' cy='11' r='1.6' fill='#0E3663' />
    </svg>
  );
}
